import { useEffect } from 'react';
import { useAppSelector } from 'store/hooks';
import { selectDeviceInfo } from 'features/application/applicationSlice';

interface UseJoinActionShortcutOptions {
  onJoin: () => void;
  disabled?: boolean;
}

/**
 * Custom hook that sets up a keyboard shortcut for joining the room.
 * - Join: Shift + Cmd/Alt + J
 */
export const useJoinActionKeyboardShortcut = (options: UseJoinActionShortcutOptions) => {
  const { onJoin, disabled = false } = options;
  const deviceInfo = useAppSelector(selectDeviceInfo);
  const isMacOS = deviceInfo.os.name === 'Mac OS';

  useEffect(() => {
    if (disabled) {
      return;
    }

    const handleKeydown = (event: KeyboardEvent) => {
      const key = event.key?.toLowerCase();
      const isMacCombo = isMacOS && event.metaKey && event.shiftKey;
      const isWindowsCombo = !isMacOS && event.altKey && event.shiftKey;

      if ((isMacCombo || isWindowsCombo) && key === 'j') {
        onJoin();
        event.preventDefault();
      }
    };

    window.addEventListener('keydown', handleKeydown);
    return () => window.removeEventListener('keydown', handleKeydown);
  }, [onJoin, isMacOS, disabled]);
};
